import endpoints from '@/utils/constants';
import { apiHelper } from '@/utils/helpers';

const actions = {
    getTaxes(context) {
            apiHelper.call('get',`${endpoints.BASE_URL}${endpoints.API.taxes}`)
            .then(res => {
                if(res.status === 200) {
                   context.commit('setTaxList', res.data);
                }
            }) 
    },
    saveTax(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post',`${endpoints.BASE_URL}${endpoints.API.taxes}`,context.state.tax)
            .then(res => {
                if(res.status === 201) {
                      resolve(res.data)
                }
            }).catch(err =>{
                reject(err);
            })
        })
    },

    fetchTax(context,taxId){
        return new Promise((resolve,reject)=>{
            apiHelper.call('get',`${endpoints.BASE_URL}${endpoints.API.taxes}/${taxId}`).then((res)=>{
                if(res.status === 201){
                    resolve(res.data)
                }
            }).catch(err =>{
                reject(err);
            })                          
        })
    },

    updateTax(context){
        return new Promise((resolve,reject)=>{
            apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.taxes}/${context.state.tax.taxId}`,context.state.tax).then((res)=> {
                if(res.status === 200)
                {
                 context.commit('setTax', res.data);
                 resolve(res);
                }
            }).catch(err =>{
                reject(err);
            })
        });
    },

}

export default actions;